import { render, staticRenderFns } from "./StoresClosures.vue?vue&type=template&id=0a173247&scoped=true&"
import script from "./StoresClosures.vue?vue&type=script&lang=ts&"
export * from "./StoresClosures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a173247",
  null
  
)

export default component.exports